"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineTrackingService = void 0;
const GlobalTrackingService_1 = require("./v1/GlobalTrackingService");
const ConsumerTrackingService_1 = require("./v1/ConsumerTrackingService");
const v2_1 = require("./v2");
__exportStar(require("./v1/types"), exports);
__exportStar(require("./v2/types"), exports);
__exportStar(require("./sanitize"), exports);
const optionalDependencies = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    's2:logger': '^1.0.0',
};
/**
 * This feature service provides tracking functionality to feature apps.
 */
function defineTrackingService(trackingProvider) {
    return {
        id: 'audi-tracking-service',
        optionalDependencies: {
            featureServices: optionalDependencies,
        },
        create(env) {
            const { datalayer = {}, sanitizeUrl } = trackingProvider;
            if (!datalayer || !sanitizeUrl) {
                throw new Error(`The tracking Service is not properly configured. datalayer: ${datalayer}, sanitizeUrl: ${sanitizeUrl}`);
            }
            // The global service is featureApp independent and has no state. It can be instantiated once.
            const globalTrackingServiceV1 = new GlobalTrackingService_1.GlobalTrackingServiceV1(datalayer);
            const globalTrackingServiceV2 = new v2_1.SharedTrackingServiceV2(datalayer, sanitizeUrl, env.featureServices['s2:logger'] || console);
            return {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                '1.0.0': (consumerId) => ({
                    featureService: new ConsumerTrackingService_1.ConsumerTrackingServiceV1(globalTrackingServiceV1, consumerId),
                }),
                // eslint-disable-next-line @typescript-eslint/naming-convention
                '2.1.0': (consumerId) => {
                    const featureService = new v2_1.ConsumerTrackingServiceV2(globalTrackingServiceV2, consumerId);
                    return {
                        featureService,
                        unbind: () => featureService.unbind(),
                    };
                },
            };
        },
    };
}
exports.defineTrackingService = defineTrackingService;
//# sourceMappingURL=index.js.map